module.exports = {
	"it": {
		"translation": {
			"moreInformation": "maggiori informazioni",
			"close": "Chiudi",
			"uploader": {
				"overlay": {
					"title": "Trascina e rilascia",
					"subtitle": "Qui i tuoi documenti"
				},
				"form": {
					"dragAndDrop": "Trascina e rilascia",
					"or": "oppure",
					"chooseFiles": "Seleziona i documenti",
					"from": "dal tuo computer"
				},
				"errors": {
					"file_size": "il documento supera le dimensioni massime di {{size}}",
					"file_type": "{{type}} è un tipo di file non corretto."
				},
				"status": {
					"idle": "inattivo",
					"processing": "in elaborazione",
					"uploading": "caricamento in corso",
					"success": "operazione riuscita",
					"cancel": "cancella",
					"error": "errore",
					"none": ""
				}
			},
			"actions": {
				"delete": "Elimina",
				"apply": "Applica",
				"cancel": "Cancella"
			},
			"dateInput": {
				"choose": "Seleziona una Data",
				"clear": "Cancella la Data"
			},
			"daterange": {
				"last_7_days": "Ultimi 7 Giorni",
				"last_30_days": "Ultimi 30 Giorni",
				"this_month": "Questo Mese",
				"last_month": "Lo scorso Mese",
				"start_date": "Data di inizio",
				"end_date": "Data di fine",
				"not_set": "Non impostato"
			},
			"comment": {
				"delete": "Elimina il commento"
			},
			"pagination": {
				"intro": "Numerazione delle pagine, attualmente a pagina {{currentPage}}",
				"page": "Pagina {{pageNumber}}",
				"ellipsis": "Più pagine",
				"prev": "Pagina precedente",
				"next": "Pagina successiva"
			},
			"formElement": {
				"optional": "(facoltativo)",
				"required": "(obbligatorio)"
			},
			"prevNextArrowButton": {
				"arrowup": "su",
				"arrowdown": "giù",
				"escape": "esci"
			},
			"externalLink": {
				"view": "visualizza"
			},
			"collapsible": {
				"ariaText": "sezione a scomparsa"
			}
		}
	}
};